var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "form-input",
      class: {
        "form-input--icon": _vm.icon,
        "form-input--disabled": _vm.disabled,
        "form-input--focused": _vm.focused,
        "form-input--error": _vm.error,
        "form-input--success": _vm.success,
        "form-input--not-empty": _vm.value != "" && _vm.value !== undefined,
      },
    },
    [
      _c(
        "div",
        { staticClass: "form-input__wrapper" },
        [
          _c("input", {
            ref: "input",
            staticClass: "form-input__field",
            class: {
              "form-input__field--valid": !_vm.error,
              "form-input__field--invalid": _vm.error,
              "form-input__field--empty": _vm.value == "",
              "form-input__field--password": _vm.type == "password",
            },
            attrs: {
              type: _vm.type,
              id: _vm.id,
              name: _vm.name,
              placeholder: _vm.placeholder,
              required: _vm.required,
              disabled: _vm.disabled,
              readonly: _vm.readonly,
              minlength: _vm.minlength,
              maxlength: _vm.maxlength,
              inputmode: _vm.inputmode,
              pattern: _vm.pattern,
            },
            domProps: { value: _vm.value },
            on: {
              input: _vm.onInput,
              focus: _vm.onFocus,
              blur: _vm.onBlur,
              keyup: _vm.onKeyup,
              keydown: _vm.onKeydown,
            },
          }),
          _vm._v(" "),
          _vm.label
            ? _c(
                "label",
                {
                  staticClass: "form-input__label | form-input-label",
                  attrs: { for: _vm.id },
                },
                [
                  _c("span", {
                    staticClass: "form-input-label__text",
                    domProps: { innerHTML: _vm._s(_vm.label) },
                  }),
                  _vm._v(" "),
                  _vm.labelOption
                    ? _c("span", {
                        staticClass: "form-input-label__option",
                        domProps: { innerHTML: _vm._s(_vm.labelOption) },
                      })
                    : _vm._e(),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.icon
            ? _c(_vm.iconComponent(_vm.icon), {
                tag: "component",
                staticClass: "form-input__icon",
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.hint
        ? _c("span", {
            staticClass: "form-input__hint | form-input-hint",
            domProps: { innerHTML: _vm._s(_vm.hint) },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.error && _vm.errorMessage
        ? _c("span", {
            staticClass: "form-input__error | form-input-error",
            domProps: { innerHTML: _vm._s(_vm.errorMessage) },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.successMessage
        ? _c("span", {
            staticClass: "form-input__success | form-input-success",
            domProps: { innerHTML: _vm._s(_vm.successMessage) },
          })
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }